<template>
  <div v-if="showFeaturePromotion && promotionActive" class="promo-badge" :class="[variantClass]">
    <div class="promo-text"><slot name="txtPromotion"></slot></div>
    <div class="info-icon" @click="showInfoModal=true"><img src="files/flash/images/svg-icons/info-icon-white.svg" alt=""></div>
    <SimonModal
      :is-visible="showInfoModal"
      @hide="showInfoModal = false"
    >
      <slot name="txtInfoIcon"></slot>
    </SimonModal>
  </div>
</template>

<script>

import promoContext from '@/mixins/promoContext'
import useFeature from '@/mixins/useFeature'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'PromoTextBadgeWithInfoIcon',
  components: { SimonModal },
  data () {
    return {
      showInfoModal: false,
      slotd: this.$slots
    }
  },
  mixins: [
    promoContext,
    useFeature('showFeaturePromotion')
  ],
  computed: {
    incentiveId: function () {
      return this.appliedIncentives?.[0]?.id
    },
    variantClass: function () {
      if (this.variant) {
        return `promo-badge-${this.variant}`
      }
      return ''
    }
  },
  props: {
    variant: {
      // Supported Values: "brush-stroke" "brush-stroke"
      type: String
    }
  }
}
</script>
